import { useFormContext } from "react-hook-form";

export const useFieldValidation = ({ fields }: { fields: string[] }) => {
  const { trigger } = useFormContext();

  const isValid = async () => {
    return await trigger(fields);
  };

  return { isValid };
};
